import { render, staticRenderFns } from "./DonorRFT.vue?vue&type=template&id=140402a6"
import script from "./DonorRFT.vue?vue&type=script&lang=js"
export * from "./DonorRFT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports